"use client";

import { c as _c } from "react/compiler-runtime";
import type { WaveGroupsConfig } from "@/types/waves.types";
import { CreateWaveGroupConfigType } from "@/types/waves.types";
import { CREATE_WAVE_NONE_GROUP_LABELS, CREATE_WAVE_SELECT_GROUP_LABELS } from "@/helpers/waves/waves.constants";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveToggle from "../utils/CreateWaveToggle";
import type { CreateWaveInlineGroupBuilderState, CreateWaveInlineGroupPanel, CreateWaveInlineGroupRuleType } from "./createWaveInlineGroupBuilder";
import CreateWaveGroupInlinePanel from "./CreateWaveGroupInlinePanel";
export default function CreateWaveGroup(t0) {
  const $ = _c(36);
  const {
    waveName,
    waveType,
    groupType,
    chatEnabled,
    adminCanDeleteDrops,
    setChatEnabled,
    onGroupSelect,
    onInlineGroupCreate,
    groupsCache,
    groups,
    groupBuilder,
    setGroupBuilderPanel,
    setGroupBuilderRule,
    setGroupBuilderDraft,
    addGroupBuilderIdentity,
    removeGroupBuilderIdentity,
    resetGroupBuilder,
    setDropsAdminCanDelete
  } = t0;
  const getSelectedGroupId = () => {
    switch (groupType) {
      case CreateWaveGroupConfigType.ADMIN:
        {
          return groups.admin;
        }
      case CreateWaveGroupConfigType.CAN_VIEW:
        {
          return groups.canView;
        }
      case CreateWaveGroupConfigType.CAN_DROP:
        {
          return groups.canDrop;
        }
      case CreateWaveGroupConfigType.CAN_VOTE:
        {
          return groups.canVote;
        }
      case CreateWaveGroupConfigType.CAN_CHAT:
        {
          return groups.canChat;
        }
      default:
        {
          return null;
        }
    }
  };
  const selectedGroupId = getSelectedGroupId();
  const selectedGroup = selectedGroupId && groupsCache[selectedGroupId] ? groupsCache[selectedGroupId] : null;
  const isNotChatWave = waveType !== ApiWaveType.Chat;
  const inputDisabled = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && !chatEnabled;
  const defaultLabel = CREATE_WAVE_NONE_GROUP_LABELS[groupType];
  const groupLabel = CREATE_WAVE_SELECT_GROUP_LABELS[waveType][groupType];
  let t1;
  if ($[0] !== groupBuilder || $[1] !== inputDisabled) {
    t1 = inputDisabled ? {
      ...groupBuilder,
      panel: "actions" as const,
      activeRule: null
    } : groupBuilder;
    $[0] = groupBuilder;
    $[1] = inputDisabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resolvedGroupBuilder = t1;
  let t2;
  if ($[3] !== groupLabel) {
    t2 = <h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-tracking-tight tw-text-iron-50 sm:tw-text-xl">{groupLabel}</h3>;
    $[3] = groupLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== chatEnabled || $[6] !== groupType || $[7] !== isNotChatWave || $[8] !== setChatEnabled) {
    t3 = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && <CreateWaveToggle enabled={chatEnabled} onChange={setChatEnabled} label="Enable chat" displayLabel={true} />;
    $[5] = chatEnabled;
    $[6] = groupType;
    $[7] = isNotChatWave;
    $[8] = setChatEnabled;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== adminCanDeleteDrops || $[11] !== groupType || $[12] !== setDropsAdminCanDelete) {
    t4 = groupType === CreateWaveGroupConfigType.ADMIN && <CreateWaveToggle enabled={adminCanDeleteDrops} onChange={setDropsAdminCanDelete} label="Allow admins to delete posts" displayLabel={true} />;
    $[10] = adminCanDeleteDrops;
    $[11] = groupType;
    $[12] = setDropsAdminCanDelete;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">{t2}{t3}{t4}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== addGroupBuilderIdentity || $[19] !== defaultLabel || $[20] !== groupLabel || $[21] !== inputDisabled || $[22] !== onGroupSelect || $[23] !== onInlineGroupCreate || $[24] !== removeGroupBuilderIdentity || $[25] !== resetGroupBuilder || $[26] !== resolvedGroupBuilder || $[27] !== selectedGroup || $[28] !== setGroupBuilderDraft || $[29] !== setGroupBuilderPanel || $[30] !== setGroupBuilderRule || $[31] !== waveName) {
    t6 = <CreateWaveGroupInlinePanel waveName={waveName} groupLabel={groupLabel} defaultLabel={defaultLabel} disabled={inputDisabled} selectedGroup={selectedGroup} groupBuilder={resolvedGroupBuilder} onGroupSelect={onGroupSelect} onInlineGroupCreate={onInlineGroupCreate} setGroupBuilderPanel={setGroupBuilderPanel} setGroupBuilderRule={setGroupBuilderRule} setGroupBuilderDraft={setGroupBuilderDraft} addGroupBuilderIdentity={addGroupBuilderIdentity} removeGroupBuilderIdentity={removeGroupBuilderIdentity} resetGroupBuilder={resetGroupBuilder} />;
    $[18] = addGroupBuilderIdentity;
    $[19] = defaultLabel;
    $[20] = groupLabel;
    $[21] = inputDisabled;
    $[22] = onGroupSelect;
    $[23] = onInlineGroupCreate;
    $[24] = removeGroupBuilderIdentity;
    $[25] = resetGroupBuilder;
    $[26] = resolvedGroupBuilder;
    $[27] = selectedGroup;
    $[28] = setGroupBuilderDraft;
    $[29] = setGroupBuilderPanel;
    $[30] = setGroupBuilderRule;
    $[31] = waveName;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== t5 || $[34] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-y-4">{t5}{t6}</div>;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  return t7;
}